import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { validateEmail } from '../../../utils';


function AddEmail(props) {
  const [email, setEmail] = useState('');
  const [isEmailValid, setIsEmailValid] = useState(false);
  const { handleAddEmail, loadingStatus } = props;

  const handleOnFormSubmit = (e) => {
    e.preventDefault();
    handleAddEmail(email);
    setEmail('');
  };
  const handleEmailChange = (e) => {
    const email = e.target.value.trim().toLowerCase();
    const isEmailValid = validateEmail(email);
    setIsEmailValid(isEmailValid);
    setEmail(e.target.value);
  };
  return (
    <form onSubmit={handleOnFormSubmit}>
      <input type="text" value={email} onChange={handleEmailChange} />
      <button className="button" type="submit" disabled={!isEmailValid}>
        {loadingStatus ? <>loading</> : <>Add Email</> }
      </button>
    </form>
  );
}
AddEmail.propTypes = {
  handleAddEmail: PropTypes.func.isRequired,
};
export default AddEmail;
